<template>
	<NewDesignModal :title="titleName" @dismiss="$emit('dismiss')">
		<div class="player-container">
			<PlexPlayer class="player" :clip="clip" :isBackdrop="false" :isActive="true"></PlexPlayer>
		</div>
	</NewDesignModal>
</template>

<script setup lang="ts">
import { Offer } from '@/@types/graphql-types';
import NewDesignModal from '@/components/modals/vfm/NewDesignModal.vue';
import { TitleDetailSeason } from '@/interfaces/title-details-graphql';
import { TrailerClip } from '@/interfaces/trailerClip';
import PlexPlayer from '@/ui-components/players/PlexPlayer.vue';
import { computed } from 'vue';

const props = defineProps<{
	offer: Offer;
	title?: TitleDetailSeason;
}>();

const titleName = computed(() => props.title?.show?.content.title ?? props.title?.content.title);

const clip = computed(
	() =>
		({
			provider: 'PLEX',
			externalId: props.offer.id,
			sourceUrl: props.offer.standardWebURL,
		} as TrailerClip)
);
</script>

<style lang="scss">
.player-container {
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.player {
	height: 100%;
	width: 100%;
	padding: 20px;
	max-height: 100% !important;

	.youtube-player__video-container {
		height: 100%;
	}
}
</style>
